/**
 * กระบวนท่าที่ได้จากอาจารย์ (moves taught one at a time): which moves of a martial art a new character may use from the
 * start; the rest stay locked on the bar until a master teaches them (the `learnMove` command, systems/moveLocks.ts,
 * called by the quest chain). The order the rest are taught in is the quest chain's, not listed here.
 */
export interface ArtUnlocks {
  /** The moves usable from the start (ids, data/skills.ts). */
  readonly start: readonly string[];
}

export const MOVE_UNLOCKS: Readonly<Record<string, ArtUnlocks>> = {
  // เพลงกระบี่ร่องศิลา: 雷 (the strong overt cut) and the basic chain only (docs/design/YARD_SLICE_STORY.md); 穿 (the
  // break) from the pupil before duel 2, 斬 (ns-heaven) from the master in step 2, the rest later.
  'nine-swords': { start: ['ns-thunder'] },
  // กระบี่ไผ่ห่มหมอก on the 256 m plains (docs/design/C0_OPENING_PLAINS.md §9.1): 風 and 刺, the least the triangle needs;
  // 掃 蘆 竹 霧 颶 颯 follow the chain (data/plainsOpening.ts). Only a character the plains opening gates.
  'breeze-sword': { start: ['bs-gust', 'bs-cloud'] },
};

/** The tooltip line of a locked move (player-facing). */
export const MOVE_LOCKED_HINT = 'ได้จากอาจารย์';

/** Is this move locked for the player: gated (`movesLearned` saved), and not learned yet (systems/moveLocks.ts). */
export const moveLocked = (pr: { readonly movesLearned?: readonly string[] | undefined }, id: string): boolean =>
  !!pr.movesLearned && !pr.movesLearned.includes(id);
